module.exports = __webpack_public_path__ + "img/organization-entities.c344e870.png";